import { IInitAction } from './init'
import { ICapability } from './capability'

// Action types
export enum types {
  GET_CAPABILITIES__STARTED = 'GET_CAPABILITIES__STARTED',
  GET_CAPABILITIES__SUCCESS = 'GET_CAPABILITIES__SUCCESS',
  GET_CAPABILITIES__FAILURE = 'GET_CAPABILITIES__FAILURE',
  UPDATE_CAPABILITIES = 'UPDATE_CAPABILITIES',
}

export interface IGetCapabilitiesAction {
  type: types.GET_CAPABILITIES__STARTED
}

export interface IGetCapabilitiesSuccessAction {
  type: types.GET_CAPABILITIES__SUCCESS
  list: ICapability[]
}

export interface IFailureAction {
  type: types.GET_CAPABILITIES__FAILURE
  message: string
}

export interface IUpdateCapabilitiesAction {
  type: types.UPDATE_CAPABILITIES
  list: ICapability[]
}

export type CapabilitiesType =
  | IGetCapabilitiesAction
  | IGetCapabilitiesSuccessAction
  | IUpdateCapabilitiesAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface ICapabilities {
  isLoading: boolean
  list: ICapability[]
}
